
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <b-card
    class="h-100 document-details border-raduis-xl border-0 box-shadow-sm py-3 px-1"
  >
    <p class="font-weight-md">{{ $t("details") }}</p>
    <div v-if="!selectDocuments.length">
      <small class="text-muted"> {{ $t("epmty_document") }}</small>
    </div>
    <div v-else>
      <div class="document-details-type">
        <div class="title">{{ $t("type_document") }}</div>

        <template v-for="type in getTypesDocumentsSelected()">
          <div
            v-b-tooltip.hover
            :title="$t('document_type.' + type.name)"
            :key="type.id"
            class="type my-3 type d-flex align-items-center justify-content-between border border-raduis-sm border-color-muted"
          >
            <span class="text-truncate"> {{ $t('document_type.' + type.name) }} </span>
            <span class="icon rounded-circle text-center text-primary">
              {{ type.number }}
            </span>
          </div>
        </template>
      </div>
      <div class="document-details-date">
        <div class="title">{{ $t("date_transmitted") }}</div>
        <p class="mb-1" v-for="doc in getDocumentsSelected()" :key="doc.id">
          {{ moment(doc.creationDate, 'x').format('DD/MM/YYYY HH:ss') }}
        </p>
      </div>
      <div class="document-notification" v-if="isADocumentToBeCompleted">
        <div class="title">{{ $t("request") }}</div>
        <p class="mb-1" v-for="doc in getDocumentsSelected()" :key="doc.id">
          {{ doc.notification.content }}
        </p>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'DocumentsDetails',
  props: ['documents', 'selectDocuments'],
  data() {
    return {};
  },
  computed: {
    isADocumentToBeCompleted() {
      let flag = false;
      const selectedDocs = this.getDocumentsSelected();
      if (selectedDocs.length === 1) {
        flag = selectedDocs[0].notification && selectedDocs[0].notification.content;
      }
      return flag;
    }
  },
  methods: {
    getDocumentsSelected() {
      const documentsSelected = [];
      this.documents.forEach(element => {
        if (this.selectDocuments.includes(element.id)) {
          documentsSelected.push(element);
        }
      });
      return documentsSelected;
    },
    getTypesDocumentsSelected() {
      const TypesDocumentsSelected = [];
      this.getDocumentsSelected().forEach(element => {
        element.types.forEach(type => {
          TypesDocumentsSelected.push({name : type});
        });
      });
      return TypesDocumentsSelected.reduce((a, b) => {
        const i = a.findIndex(x => x.name === b.name);
        if (i === -1) {
          return (a.push({ id: b.id, name: b.name, number: 1 }), a);
        } else {
          return (a[i].number++, a);
        }
      }, []);
    }
  }
};
</script>
